import React from "react";
import moment from "moment";

import { Visibility } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const CancelOrders = ({ data, showType }) => {
  let history = useHistory();

  return (
    <div
      className={`tab-pane fade ${showType === 2 && "show active"}`}
      id="denied-md"
      role="tabpanel"
      aria-labelledby="denied-tab-md"
      style={{ textAlignLast: "center" }}
    >
      <table
        id="dtBasicExample"
        className="table table-striped table-bordered table-hover table-lg "
        cellSpacing="0"
        width="100%"
      >
        <thead>
          <tr>
            <th style={{ fontWeight: 500 }}>Sipariş No</th>
            <th style={{ fontWeight: 500 }}>Sipariş Tarihi</th>
            <th style={{ fontWeight: 500 }}>Müşteri Adı</th>
            <th style={{ fontWeight: 500 }}>Bölge</th>
            <th style={{ fontWeight: 500 }}>Tutar</th>
            <th style={{ fontWeight: 500 }}>Onay Durumu</th>
            <th style={{ fontWeight: 500 }}>Reddedilme Sebebi</th>
          </tr>
        </thead>
        {data.map((orders, index) => {
          return (
            orders.order_state === 800 && (
              <tbody key={index}>
                <tr id="deniedOrdersRow">
                  <td>{orders.order_id}</td>
                  <td>
                    {moment(orders.createdAt).locale("tr").format("L")}
                    <br />
                    {moment(orders.createdAt).locale("tr").format("LTS")}
                  </td>
                  <td>{orders.client_name}</td>
                  <td>{orders.delivery_address}</td>
                  <td>
                    {orders.total_discounted_price !== null
                      ? orders.total_discounted_price
                      : orders.total_price}{" "}
                    ₺
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-blue btn-rounded btn-sm m-1 approve-buttons"
                      onClick={() => history.push("/orderdetail", orders)}
                      style={{ borderRadius: 7 }}
                    >
                      <Visibility style={{ width: 20, marginBottom: 3 }} />
                      <span style={{ marginLeft: 3, fontSize: 14 }}>
                        Detaylar
                      </span>
                    </button>
                  </td>
                  <td>
                    {orders.cancelledreasons.length === 0
                      ? "İptal nedeni bilinmiyor"
                      : orders.cancelledreasons[0].cancelled_reason}
                  </td>
                </tr>
              </tbody>
            )
          );
        })}
      </table>
    </div>
  );
};

export default CancelOrders;
